@if (collections.length > 0) {
  <div>
    <div class="h-48 p-2 flex justify-between items-center bg-white shadow">
      <div class="flex items-center gap-2 pl-3">
        <dg-breadcrumb-list [breadcrumbs]="breadcrumbs" (action)="onBreadcrumb($event)"></dg-breadcrumb-list>
      </div>
      <dg-collection-toolbar
        [activeViewMode]="viewMode$ | async"
        (changeViewMode)="onChangeCollectionViewMode($event)"
      ></dg-collection-toolbar>
    </div>
    <div class="p-2">
      <dg-collection-list
        [collections]="collections"
        [viewMode]="viewMode$ | async"
        (action)="onCollection($event)"
      ></dg-collection-list>
    </div>
  </div>
}

@if (rootCollections.length > 0 && collections.length === 0 && records.length === 0) {
  <div>
    <div class="h-48 p-2 flex justify-between items-center bg-white shadow">
      <div class="flex items-center gap-2 pl-3">
        <dg-breadcrumb-list [breadcrumbs]="breadcrumbs" (action)="onBreadcrumb($event)"></dg-breadcrumb-list>
      </div>
      <dg-collection-toolbar
        [activeViewMode]="viewMode$ | async"
        (changeViewMode)="onChangeCollectionViewMode($event)"
      ></dg-collection-toolbar>
    </div>
    <div class="p-2">
      <dg-collection-list
        [collections]="rootCollections"
        [viewMode]="viewMode$ | async"
        (action)="onCollection($event)"
      ></dg-collection-list>
    </div>
  </div>
}
